export const keyboardCodes = [
  // エンターキー
  // Enter key
  'Enter',
];
